export default function initAppState() {
  let switching = false;
  let changeHandler = null;
  return {
    isSwitching() {
      return switching;
    },
    startSwitching() {
      switching = true;
      if (changeHandler) {
        changeHandler(true);
      }
    },
    stopSwitching() {
      switching = false;
      if (changeHandler) {
        changeHandler(false);
      }
    },
    setChangeHandler(changeFunc) {
      changeHandler = changeFunc;
    }
  };
}


// WEBPACK FOOTER //
// ./jsapp/learnRuntime/initAppState.js